module.exports = __webpack_public_path__ + "img/3.f952e9e3.png";